import { apiSlice } from 'state/slices/apiSlice';

const ATTENDANCE_URL = '/attendances';

export const attendanceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateAttendanceSheet: builder.mutation({
      query: (data) => {
        return {
          url: `${ATTENDANCE_URL}/sheet/merge`,
          method: 'PUT',
          body: data,
        };
      }
    }),
    getAttendancesById: builder.query({
      query: ({ year, month, id}) => `${ATTENDANCE_URL}/${year}/${month}/${id}`,
      extraOptions: { skipToastOn: [404] },
    }),
    getAttendances: builder.query({
      query: ({ year, month }) => `${ATTENDANCE_URL}/${year}/${month}`,
    }),
    markAttendances: builder.mutation({
      query: (data) => {
        return {
          url: `${ATTENDANCE_URL}/mark`,
          method: 'POST',
          body: data,
        };
      }
    }),
  }),
});

export const {
  useUpdateAttendanceSheetMutation,
  useGetAttendancesByIdQuery,
  useGetAttendancesQuery,
  useMarkAttendancesMutation,
} = attendanceApiSlice;
